import ky from 'ky';

export const carmaCsrBizClient = ky.create({
  prefixUrl: `${process.env.NEXT_PUBLIC_BIZ_API_URL}/`,
  timeout: 15000,
});
